import React from 'react';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { StyledSelectInput } from '../StyledSelectInput';

export const Specialty = () => {
  const {
    modelPrefix,
    onBlur,
    isSpecialityFieldRequired,
    specialtyTypes,
    specialtyTypeFlag,
    typesSubText,
    typesErrorPlaceholder,
  } = usePropsContext();

  const checkIsRequired = () => {
    if (!isSpecialityFieldRequired) {
      return false;
    }
    if (!specialtyTypeFlag.isError) {
      return 'Please select a value';
    }
    // if required and there's an error, return (!)
    return '(!)';
  };

  const requiredResponse = checkIsRequired();

  return (
    <StyledSelectInput
      labelKey="referenceDesc"
      valueKey="referenceCode"
      data-testid="specialty"
      label="Specialty"
      placeholder={specialtyTypeFlag.isError ? typesErrorPlaceholder : ''}
      model={`${modelPrefix}.specialtyCode`}
      validators={{
        // Only display 'Please select a value' when there isn't an error
        required: requiredResponse,
      }}
      options={specialtyTypes || []}
      subText={
        specialtyTypeFlag.isError && isSpecialityFieldRequired
          ? typesSubText
          : ''
      }
      isError={specialtyTypeFlag.isError}
      enableOutsideScroll
      isClearable
      width="50%"
      onBlur={() => onBlur(`${modelPrefix}.specialtyCode`)}
    />
  );
};
